import { render } from "./CartModal.vue?vue&type=template&id=daf835da&scoped=true&ts=true"
import script from "./CartModal.vue?vue&type=script&lang=ts"
export * from "./CartModal.vue?vue&type=script&lang=ts"

import "./CartModal.vue?vue&type=style&index=0&id=daf835da&scoped=true&lang=scss"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf835da"]])

export default __exports__